import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import cl from './Articles.module.css';
import B2BService from '../../API/B2BService';
import { IconClock, IconEye, IconArrowRight } from '../../components/icons';
import usePageMeta from '../../hooks/usePageMeta';
import Spinner from '../../components/Spinner';

// Список статей категории «integration». Подтягивается с
// b2b-микросервиса, который проксирует к admin-микросервису.
// Клик ведёт на внутреннюю страницу /articles/:id (комментарии там же).
export default function Articles() {
    usePageMeta({
        title: 'Статьи и материалы · СтартКласс',
        description: 'Кейсы и практические рекомендации по запуску IT-направления в детском центре: оборудование, преподаватели, программа.',
        canonical: 'https://startklass.ru/articles',
    });

    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        B2BService.getArticles({ category: 'integration' }).then(list => {
            // Сортировка: больше просмотров — выше (чтобы топовые были вверху).
            // Если просмотров одинаково — сначала новые.
            list.sort((a, b) => {
                const v = (b.views_count || 0) - (a.views_count || 0);
                if (v !== 0) return v;
                return (b.created_at || '').localeCompare(a.created_at || '');
            });
            setArticles(list);
            setLoading(false);
        });
    }, []);

    return (
        <main className={cl.page}>
            <div className={cl.head}>
                <span className={cl.eyebrow}>Статьи и материалы</span>
                <h1 className={cl.title}>
                    Как открыть IT-направление в детском центре
                </h1>
                <p className={cl.subtitle}>
                    Кейсы, разборы и практические рекомендации по внедрению
                    программирования и робототехники. <b>Доступны без регистрации.</b>
                </p>
            </div>

            {loading ? (
                <Spinner size="large" text="Загружаем статьи" fullPage center/>
            ) : articles.length === 0 ? (
                <div className={cl.empty}>Статей пока нет.</div>
            ) : (
                <div className={cl.grid}>
                    {articles.map(a => (
                        <Link key={a.id} to={`/articles/${a.id}`} className={cl.card}>
                            <div className={cl.meta}>
                                <span><IconClock width={13} height={13}/> {a.estimated_read_time} мин</span>
                                <span><IconEye width={13} height={13}/> {a.views_count} прочтений</span>
                            </div>
                            <h3 className={cl.cardTitle}>{a.title}</h3>
                            <p className={cl.cardSummary}>{a.summary}</p>
                            <span className={cl.cardFooter}>
                                Читать статью <IconArrowRight width={13} height={13}/>
                            </span>
                        </Link>
                    ))}
                </div>
            )}
        </main>
    );
}
